export enum ApartmentSubType {
  DUPLEX_OR_TRIPLEX = 'DUPLEX_OR_TRIPLEX',
  PENTHOUSE = 'PENTHOUSE',
  APARTMENT = 'APARTMENT'
}
